import { render, staticRenderFns } from "./setCode.vue?vue&type=template&id=1e9d34e7&scoped=true&"
import script from "./setCode.vue?vue&type=script&lang=ts&"
export * from "./setCode.vue?vue&type=script&lang=ts&"
import style0 from "./setCode.vue?vue&type=style&index=0&id=1e9d34e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9d34e7",
  null
  
)

export default component.exports